import { Allow, parse } from "partial-json";

/**
 * Parses a possibly-truncated JSON string and returns the most complete
 * object it can synthesize. Used to read tool-call args incrementally as
 * `flow_message.tool_call_args_delta` events stream in.
 *
 * Strict primitives: only OBJ / ARR are allowed to be partial — primitive
 * values (strings, numbers, etc.) are omitted from the result until they
 * are fully settled (closing `"` for strings, structural separator after
 * numbers). This guarantees consumers never see half-streamed strings
 * (e.g. "Creat..." for "Creating notes...") or partial integers that
 * could mis-position a placement.
 *
 * Returns `undefined` on unrecoverable malformed input. Callers should
 * still type-guard the fields they care about; a partial buffer can omit
 * keys entirely.
 */
export function parsePartialJson(buffer: string): unknown {
  if (!buffer) return undefined;
  try {
    return parse(buffer, Allow.OBJ | Allow.ARR);
  } catch {
    return undefined;
  }
}
